export const getRankBadgeUrl = (rankKey: string) => {
  const normalized = String(rankKey || "").trim().toLowerCase();
  if (!normalized) return "";
  return `/agency-assets/ranks/${normalized}.png`;
};
